const pages = {
  //Dashboard Module

  signIn: {
    ID: "sign-in",
    route: "/sign-in",
  },

  signUp: {
    ID: "sign-up",
    route: "/sign-up",
  },

  home: {
    ID: "home",
    route: "/",
  },

  verifyAccount: {
    ID: "verify-account",
    route: "/verify/",
  },

  brandDetailCreateEmpty: {
    ID: "create-brand-empty",
    route: "/create-brand-details",
  },

  brandDetailEmpty: {
    ID: "create-brand-empty-details",
    route: "/brand/create",
  },

  brandDetails: {
    ID: "brand-details",
    route: "/brand/details",
  },

  companyDetails: {
    ID: "company-details",
    route: "/company-details-page",
  },

  companyDetailsCreateEmpty: {
    ID: "company-details-create-empty",
    route: "/create-company-details",
  },

  companyDetailsEmpty: {
    ID: "company-details-empty",
    route: "/company-details",
  },

  myCampaign: {
    ID: "my-campaign",
    route: "/campaign/all",
  },

  createCampaign: {
    ID: "create-campaign",
    route: "/campaign/create",
  },

  campaignDetails: {
    ID: "campaign-details",
    route: "/campaign/",
  },

  audienceList: {
    ID: "audience-list",
    route: "/audience/all",
  },

  createAudience: {
    ID: "create-audience",
    route: "/audience/create",
  },

  audienceDetails: {
    ID: "audience-details",
    route: "/audience/",
  },

  exploreConnections: {
    ID: "explore-connections",
    route: "/my-connections",
  },

  connectionDetails: {
    ID: "connection-details",
    route: "/connection-details/",
  },

  welcomePage: {
    ID: "welcome-page",
    route: "/landing-page",
  },

  changePassword: {
    ID: "change-password",
    route: "/change-password",
  },

  resetEmailPasswordPage: {
    ID: "reset-email-password",
    route: "/reset-password",
  },

  forgotPasswordPage: {
    ID: "forgot-password",
    route: "/forgot-password/",
  },

  createWelcomePage: {
    ID: "create-welcome-page",
    route: "/setup-brand-page",
  },

  adminWelcomePage: {
    ID: "admin-welcome-page",
    route: "/admin-landing-page",
  },

  channelAgentSettingPage: {
    ID: "channel-setting-page",
    route: "/channel-setting-page",
  },

  profilePage: {
    ID: "profile-page",
    route: "/profile-page",
  },

  reportingPage: {
    ID: "reporting-page",
    route: "/reporting-page",
  },

  //AGENCY

  welcomeAsAgencyPage: {
    ID: "welcome-agency",
    route: "/welcome-agency",
  },

  agencyBrandsPage: {
    ID: "brands-agency",
    route: "/brand/all",
  },

  createAgencyPage: {
    ID: "create-agency",
    route: "/create-agency",
  },

  agencyDetailsEmptyPage: {
    ID: "agency-details-empty",
    route: "/agency-details",
  },

  agencyEmptyDetailBrandPage: {
    ID: "agency-brand-details-empty",
    route: "/agency-brand-details",
  },

  agencyDashboardDetailPage: {
    ID: "agency-dashboard-details",
    route: "/agency-details-dashboard",
  },

  //misc
  permissionDenied: {
    ID: "permission",
    route: "/permission-denied",
  },

  whatsAppOnboardingPage: {
    ID: "whatsapp-onboarding",
    route: "/whatsapp-onboarding",
  },

  createOnboardLink: {
    ID: "createOnboardLink",
    route: "/create-onboard-link/",
  },

  botDetailsPage: {
    ID: "botDetailsPage",
    route: "/bot-details/",
  },
};

export default pages;
